import { render, staticRenderFns } from "./HeaderTabList.vue?vue&type=template&id=10b2ac05&"
import script from "./HeaderTabList.vue?vue&type=script&lang=js&"
export * from "./HeaderTabList.vue?vue&type=script&lang=js&"
import style0 from "./HeaderTabList.vue?vue&type=style&index=0&id=10b2ac05&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports